import React from "react";

import SetaCard from "../../img/arrow-right-line.svg";
import iconesDisponibilidade from "../../img/configuracaoDisponibilidade";

/*
🔹 Componente Card
------------------------------------------------------------
Responsável por exibir um projeto em formato resumido,
geralmente utilizado em listas e carrosséis.

Este componente é totalmente orientado a dados (JSON),
ou seja, sua renderização depende da estrutura do objeto "projeto".

📌 Suporta diferentes tipos de mídia:
• imagem
• vídeo local
• SVG
• YouTube (iframe)

📌 Também exibe:
• tags do projeto
• ícones de disponibilidade (dinâmicos)
• ação de navegação (onClick)
------------------------------------------------------------
*/

function Card({ projeto, onClick }) {

  /*
  🔹 "apresentacao" define como a mídia será exibida.
  Essa estrutura vem diretamente do JSON.
  
  Exemplo:
  {
    tipo: "imagem" | "video" | "youtube" | "svg",
    arquivo: "...",
    url: "..."
  }
  */
  const { apresentacao } = projeto;

  return (
    <div
      className="card"
      onClick={function () {
        // 🔹 Ao clicar no card, delegamos a ação para o componente pai
        // (geralmente navegação para página de detalhes)
        onClick(projeto.id);
      }}
    >

      {/* ========================= MÍDIA ========================= */}
      <div className="card-media">

        {/* 🔹 Vídeo local */}
        {apresentacao.tipo === "video" && (
          <video
            src={apresentacao.arquivo}
            controls
            className="card-video"
          />
        )}

        {/* 🔹 Imagem comum */}
        {apresentacao.tipo === "imagem" && (
          <img
            src={apresentacao.arquivo}
            alt={projeto.titulo}
            className="card-image"
          />
        )}

        {/* 🔹 SVG (tratado como imagem) */}
        {apresentacao.tipo === "svg" && (
          <img
            src={apresentacao.arquivo}
            alt={projeto.titulo}
            className="card-image"
          />
        )}

        {/* 🔹 Vídeo do YouTube (embed via iframe) */}
        {apresentacao.tipo === "youtube" && (
          <iframe
            src={apresentacao.url}
            title={projeto.titulo}
            className="card-video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        )}

      </div>

      {/* ========================= CONTEÚDO ========================= */}
      <div className="card-content">

        {/* 🔹 Lista de tags do projeto */}
        <div className="card-tags">

          {/* 🔹 Tags (lado esquerdo) */}
          <div className="card-tags-lista">
            {projeto.tags.slice(0, 2).map(function (tag, index) {
              return (
                <span className="card-tag" key={index}>
                  {tag + " "}
                </span>
              );
            })}
          </div>

          {/* 🔹 Ícones (lado direito) */}
          <div className="card-disponibilidade">
            {projeto.disponibilidade && projeto.disponibilidade.map(function (item, index) {

              const config = iconesDisponibilidade[item.tipo];

              if (!config) {
                return null;
              }

              return (
                <img
                  key={index}
                  src={config.icone}
                  alt={config.label}
                  className="card-icone"
                />
              );

            })}
          </div>

        </div>

        {/* 🔹 Título do projeto */}
        <h3 className="card-title">{projeto.titulo}</h3>

        {/* 🔹 Descrição curta */}
        <p className="card-description">{projeto.descricao}</p>

        {/* 🔹 Indicador visual de ação (seta) */}
        <div className="card-acao">
          <img
            src={SetaCard}
            alt="ver projeto"
            className="card-seta"
          />
        </div>

      </div>
    </div>
  );
}

export default Card;